import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PublicNavBar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="text-ink-900 bg-sand-100 border-b-4 border-coral-300">
      <div className="max-w-6xl mx-auto px-2 sm:px-4">
        <div className="flex justify-between items-center h-16 sm:h-20 md:h-24">
          
          {/* Logo */}
          <div className="flex items-center">
            <div onClick={() => navigate('/')} className="cursor-pointer hover:opacity-80 transition-opacity">
              <img 
                src="/images/teaich-logo.png" 
                alt="TeAIch" 
                className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto" 
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-4 lg:space-x-8">
            <button 
              onClick={() => navigate('/')} 
              className="text-base lg:text-lg py-2 px-2 lg:px-3 rounded transition-colors font-medium text-coral-600 hover:text-coral-800"
            >
              Home
            </button>
            <button 
              onClick={() => navigate('/tools')} 
              className="text-base lg:text-lg py-2 px-2 lg:px-3 rounded transition-colors font-medium text-coral-600 hover:text-coral-800"
            >
              Tools
            </button>
            <button 
              onClick={() => navigate('/pricing')} 
              className="text-base lg:text-lg py-2 px-2 lg:px-3 rounded transition-colors font-medium text-coral-600 hover:text-coral-800"
            >
              Pricing
            </button>
            <button 
              onClick={() => navigate('/contact')} 
              className="text-base lg:text-lg py-2 px-2 lg:px-3 rounded transition-colors font-medium text-coral-600 hover:text-coral-800"
            >
              Contact
            </button>
            <button 
              onClick={() => navigate('/login')} 
              className="text-base lg:text-lg py-2 px-2 lg:px-3 rounded transition-colors font-medium text-coral-600 hover:text-coral-800"
            >
              Login
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-coral-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-2 border-t border-coral-300">
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => { navigate('/'); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-600 hover:bg-coral-500 hover:text-white"
              >
                Home
              </button>
              <button 
                onClick={() => { navigate('/tools'); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-600 hover:bg-coral-500 hover:text-white"
              >
                Tools
              </button>
              <button 
                onClick={() => { navigate('/pricing'); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-600 hover:bg-coral-500 hover:text-white"
              >
                Pricing
              </button>
              <button 
                onClick={() => { navigate('/contact'); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-600 hover:bg-coral-500 hover:text-white"
              >
                Contact
              </button>
              <button 
                onClick={() => { navigate('/login'); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-600 hover:bg-coral-500 hover:text-white"
              >
                Login
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNavBar;